import { sanitize } from '@/lib/sanitize'
import { YouTubeEmbed } from '@next/third-parties/google'
import parse from 'html-react-parser'

export function convertContent(content: string) {
  return parse(sanitize(content), {
    replace: (domNode) => {
      if (domNode.type === 'tag' && domNode.name === 'iframe') {
        const { attribs } = domNode
        const url = new URL(attribs.src)
        const videoId = url.pathname.split('/').pop()

        if (videoId) {
          return (
            <div className="mb-3">
              <YouTubeEmbed videoid={videoId} />
            </div>
          )
        }
      }
    },
  })
}
